import React, { Fragment, useEffect } from 'react';
import { Col, DatePicker, Form, InputNumber, message, Modal, Row, Select } from 'antd';
import * as CommonService from '../../../../services/CommonService';
import { RECEIPT_ENDPOINT } from '../../../../services/endpoint';
import moment from 'moment';
import { formatCurrency, parserNumber } from '../../../../utils';
import { PAYMENT_METHOD } from '../../../../utils/const';
import TextArea from 'antd/es/input/TextArea';

const { Option } = Select;

const CreateTicket = (props) => {

	const { visible, setVisible, callback, isIncome, customerId } = props;

	const [btnLoading, setBtnLoading] = React.useState(false);
	const [title, setTitle] = React.useState(false);

	useEffect(() => {
		if (isIncome) {
			setTitle('thu');
		} else {
			setTitle('chi');
		}
	}, [isIncome]);

	const { getFieldDecorator } = props.form;

	const handleAdd = (e) => {
		e.preventDefault();
		props.form.validateFields(async (err, values) => {
			if (!err) {
				const body = {
					...values,
					branchId: 'e8bf060b-c0c9-4e6e-80fe-b2f76c89aa70', // temporary
					customerId,
					isIncome
				};
				delete body.date;
				setBtnLoading(true);
				CommonService.create(RECEIPT_ENDPOINT, body).then(res => {
					setVisible(false);
					if (res) {
						if (callback) {
							callback(res);
						}
						props.form.resetFields();
					}
					message.success('Thêm thành công ' + title);
				}).catch(err => {
					message.error(err?.data?.message || 'Có lỗi xảy ra');
				}).finally(() => setBtnLoading(false));
			}
		});
	};

	const renderOptions = () => {
		return Object.keys(PAYMENT_METHOD).map(el => <Option value={el}>{PAYMENT_METHOD[el]}</Option>);
	};

	return <Fragment>
		<Modal
			title={'Tạo phiếu ' + title}
			visible={visible}
			onOk={handleAdd}
			confirmLoading={btnLoading}
			onCancel={() => {
				setVisible(false);
				props.form.resetFields();
			}}
		>
			<Form>
				<Row gutter={12}>
					<Col span={12}>
						<Form.Item label="Chi nhánh" required={true}>
							{getFieldDecorator('branchId', {
								rules: [
									{
										required: true
									}
								],
								initialValue: '1'
							})(<Select disabled>
								<Option value={'1'}>SurfaceCity</Option>
							</Select>)}
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Ngày ghi nhận" required={true}>
							{getFieldDecorator('date', {
								rules: [
									{
										required: true,
										message: 'Vui lòng chọn ngày ghi nhận'
									}
								],
								initialValue: moment(new Date())
							})(<DatePicker
								disabled
								style={{ width: '100%' }}
								allowClear
								showTime={{ format: 'HH:mm:ss' }}
								format="YYYY-MM-DD HH:mm:ss"
								placeholder={'Chọn ngày ghi nhận'}
							/>)}
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Giá trị" required={true}>
							{getFieldDecorator('amount', {
								rules: [
									{
										required: true,
										message: 'Vui lòng nhập giá trị'
									}
								]
							})(<InputNumber style={{ width: '100%' }} formatter={formatCurrency}
															placeholder={'Nhập giá trị'}
															parser={parserNumber} min={1} />)}
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label={`Phương thức thanh toán`} required>
							{getFieldDecorator(`paymentMethod`, {
								initialValue: 'CASH',
								rules: [
									{
										required: true,
										message: 'Vui lòng chọn phương thức thanh toán'
									}
								]
							})(<Select placeholder="Chọn phương thức thanh toán" style={{ width: '100%' }}>
								{renderOptions()}
							</Select>)}
						</Form.Item>
					</Col>
					<Col span={24}>
						<Form.Item label={`Mô tả`}>
							{getFieldDecorator(`description`, {})(<TextArea rows={5} placeholder="Nhập mô tả"
																															style={{ width: '100%' }} />)}
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	</Fragment>;
};

export default Form.create({ name: 'CreateTicket' })(CreateTicket);
